<script lang="ts">
    import {_} from "svelte-i18n"
    import Head from "../header/Head.svelte";
    import Navbar from "../header/Navbar.svelte";
    import ProjectRow from "./ProjectRow.svelte";
    import Footer from "../footer/Footer.svelte";
    import NewProjectModal from "../project/NewProjectModal.svelte";
    import { onMount } from "svelte";
    import { appManager } from "../AppManager";
    import type { ProjectAndScenariosData } from "../api/projects/data/projects/ProjectAndScenariosData";

    let projects: ProjectAndScenariosData[] = [];

    /**
     * If set: show a banner for this organisation and only show projects by this organisation
     * This allows to use this component for both the 'userhome' and the 'organisationHome'
     */
    export let organization: string = undefined

    let createNewDialogOpen = false;
    const onShowCreateNew = () => {
        createNewDialogOpen = true;
    }

    let searchString: string = "";

    $: onSearch(searchString);

    async function onSearch(q: string) {
        projects = await appManager.api.projects.getUserProjects({
            accessToken: await appManager.api.getAccessToken(),
            q: q,
        });
        if (organization) {
            projects = projects.filter(proj => proj.organization.name === organization);
        }

        sortProjects();
    }

    const sortProjects = () => {
        projects.sort((a, b) => {
            const aTime = a.lastModified ?? a.createdAt;
            const bTime = b.lastModified ?? b.createdAt;

            return bTime.getTime() - aTime.getTime();
        });
    }

    onMount(async () => {
        projects = await appManager.api.projects.getUserProjects({
            accessToken: await appManager.api.getAccessToken(),
            q: "",
        });

        sortProjects();
    });

    const setCanCreate = async () => {};

    let canOpenProject = true;
    appManager.getCanOpenProjects().subscribe((id) => {
        canOpenProject = id;
    })
</script>

{#await setCanCreate()}
    <div/>
{/await}

<Head/>

<Navbar isDark={false}/>

<NewProjectModal bind:open={createNewDialogOpen}/>

<section class="py-6 bg-light">
    <div class="container">
        {#if organization !== undefined}
            <div class="row">
                <h1>{organization}</h1>
            </div>
        {/if}
        <div class="row">
            <div class="{canOpenProject ? 'col' : 'col'}">
                <div class="rounded shadow">
                    <div class="input-group input-group-lg">
                        <span class="input-group-text border-0 pe-1">
                            <i class="fe fe-search"/>
                        </span>

                        <input
                                aria-label="{$_('impact.userhome.search')}"
                                bind:value={searchString}
                                class="form-control border-0 px-1"
                                placeholder="{$_('impact.userhome.search')}"
                                type="text"/>

                        <span class="input-group-text border-0 py-0 ps-1 pe-3">
                            <span
                                    class="h6 text-uppercase text-muted d-none d-md-block mb-0 me-5">
                                {#if projects.length == 1}
                                       {$_("impact.userhome.project")}
                                {:else}
                                       {$_("impact.userhome.projects", {values: {n: projects.length}})}
                                {/if}
                            </span>
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-auto">
                {#if canOpenProject}
                    <div class="rounded shadow">
                        <div class="input-group input-group-lg ">
                            <button
                                    class="btn btn-sm btn-primary w-100"
                                    on:click={onShowCreateNew}>
                                {$_("impact.userhome.newProject")}
                            </button>
                        </div>
                    </div>
                {/if}
            </div>
        </div>
    </div>
</section>


<section class="bg-light min-height">
    <div class="container">
        <div class="row">
            {#each projects as projectData}
                {#if typeof projectData.scenarios !== "undefined" && projectData.scenarios.length > 0}
                    <ProjectRow {projectData}/>
                {/if}
            {/each}
            {#if projects.length === 0 && (canOpenProject)}
            <div class="col-12 col-md-6">
                <p class="text-gray-800 mb-6 mb-md-8">
                    {$_('impact.userhome.noproject.part1')}<a class="a" on:click={onShowCreateNew} on:keypress={() => {}}>{$_('impact.userhome.noproject.part2')}</a>.
                </p>
            </div>
            {/if}
        </div>
    </div>
</section>
<Footer/>

<style>
    .min-height {
        min-height: calc(100vh - 560px);
    }
</style>